<script>
    import AdminBar from "../../../components/AdminBar.svelte";
    import Foot from "../../../components/Foot.svelte";
    import Balances from "./components/Balances.svelte";
    import WalletOperation from "./components/WalletOperation.svelte";
    import TxTable from "./components/TxTable.svelte";
    import FindBar from "../../../components/FindBar.svelte";
    import {backofficeServiceHost, userRef} from "../../../stores/magic-wallet-store";

    let txs
    let selectedBalance
    let balances

    const searchByUserRef = async () => {
        if (myUserRef && myUserRef.length > 0) {
            userRef.set(myUserRef)
            balances = ((await (await fetch(`${backofficeServiceHost}/magic-wallet/balance?userRef=${myUserRef}`)).json()).balanceMap)
        }
    }

    const selectBalance = async (balance) => {
        if (balance) {
            selectedBalance = balance
            txs = (await (await fetch(`${backofficeServiceHost}/magic-wallet/transactionsFor?userRef=${myUserRef}&currency=${balance[0]}&page=${0}&pageSize=20`)).json())
            console.log(txs)
        }
    }

    const updateFunction = () => {
        searchByUserRef()
        selectBalance(selectedBalance)
    }

    let myUserRef

    userRef.subscribe(value => {
        if (value && value.length > 0) {
            myUserRef = value
            searchByUserRef()
        }
    })
</script>

<AdminBar/>

<main>
    <section class="introduction-section">
        <h1>Magic Wallet</h1>
        <FindBar labelText="Goosicorn UserRef" bind:criteria={myUserRef} searchFunction={searchByUserRef}/>
    </section>
    <section class="selection-section">
        <section class="balance-section">
            <Balances bind:balances={balances} bind:selectedBalance={selectedBalance} selectBalanceFunction={selectBalance}/>
        </section>
        <section class="wallet-operation-section">
            <WalletOperation bind:userRef={myUserRef} bind:selectedBalance={selectedBalance} updateFunction={updateFunction}/>
        </section>
    </section>
    <section class="table-section">
        <TxTable bind:txs={txs}/>
    </section>
</main>

<Foot/>

<style>
    main {
        width: 98%;
        margin: 10px auto;
    }

    .selection-section, .introduction-section, .balance-section, .wallet-operation-section {
        width: 100%;
        /*border: solid 1px black;*/
    }

    .selection-section {
        display: flex;
    }

</style>
